export enum PageType {
    Home = 1,
    FruitListing = 2,
    FruitCategory = 3,
    FruitDetail = 4,
    Contact = 5,
    Static = 6,   
    WhereToBuy = 7
}

export enum ContainerType{
    Main = 1,
    Thumbnail = 2,
}

export enum ControlTypes {
    TextBox = 1,
    TextArea = 2,
    ImageUploadSingle = 3,
    ImageUploadMultiple = 4,
    FileUploadSingle = 5,
    FileUploadMultiple = 6,
    Seasons = 7,
    Radio = 8,
    Testimonial = 9
}


export enum MapSearchType{
    Current = 1,
    Address = 2,
    Store = 3
}